<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full">
        <label><strong>{{ $t('restaurant.ID') }}</strong></label>
        <p>{{ restaurantForm.id }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full">
        <label><strong>{{ $t('restaurant.URL') }}</strong></label>
        <p>{{ restaurantForm.slug }}</p>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('restaurant.Info') }}</h4>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Nombre') }}</strong></label>
        <p>{{ restaurantForm.name }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>CIF</strong></label>
        <p>{{ restaurantForm.cif }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('CompanyName') }}</strong></label>
        <p>{{ restaurantForm.company_name }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('TfnoReservas') }}</strong></label>
        <p>{{ restaurantForm.phone_bookings }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('TfnoGestion') }}</strong></label>
        <p>{{ restaurantForm.phone_management }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label
          ><strong>{{ $t('Whatsapp') }}</strong></label
        >
        <p>{{ restaurantForm.whatsapp }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Email') }}</strong></label>
        <p>{{ restaurantForm.email }}</p>
      </div>
      <div class="vx-col w-full mb-3">
        <label><strong>Web</strong></label>
        <p>{{ restaurantForm.web }}</p>
      </div>
      <div class="vx-col w-full mb-3">
        <label><strong>{{ $t('Descripcion') }}</strong></label>
        <p>{{ restaurantForm.description }}</p>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-3">
        <label><strong>{{ $t('restaurant.TipoCocina') }}</strong></label>
        <div>
          <span
            class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
            v-if="restaurantForm.types.includes(item.id)"
            v-for="item in listTypes"
          >
            {{ item.name }}
          </span>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-3">
        <label><strong>{{ $t('Perfil') }}</strong></label>
        <div>
          <span
            class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
            v-if="restaurantForm.profiles.includes(item.id)"
            v-for="item in listProfiles"
          >
            {{ item.name }}
          </span>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-3">
        <label><strong>{{ $t('Idiomas') }}</strong></label>
        <div>
          <span
            class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
            v-if="languages[lang]"
            v-for="lang in restaurantForm.languages"
          >
            {{ languages[lang] }}
          </span>
        </div>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('IVA') }}</strong></label>
        <p>{{ restaurantForm.iva }}</p>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('restaurant.Responsables') }}</h4>
      </div>
      <div class="vx-col w-full mt-3 mb-2">
        <h5><strong>{{ $t('Principal') }}</strong></h5>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Nombre') }}</strong></label>
        <p>{{ restaurantForm.responsable_name }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Telefono') }}</strong></label>
        <p>{{ restaurantForm.responsable_phone }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Puesto') }}</strong></label>
        <p>{{ restaurantForm.responsable_position }}</p>
      </div>
      <div class="vx-col w-full mb-2">
        <h5><strong>{{ $t('Secundario') }}</strong></h5>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Nombre') }}</strong></label>
        <p>{{ restaurantForm.responsable_phone_2 }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Telefono') }}</strong></label>
        <p>{{ restaurantForm.responsable_phone_2 }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Puesto') }}</strong></label>
        <p>{{ restaurantForm.responsable_position_2 }}</p>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('Ubicacion') }}</h4>
      </div>
      <div class="vx-col md:w-2/3 w-full mb-3">
        <label><strong>{{ $t('Address') }}</strong></label>
        <p>{{ restaurantForm.address }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('CodigoPostal') }}</strong></label>
        <p>{{ restaurantForm.postalCode }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Municipio') }}</strong></label>
        <p>{{ restaurantForm.municipality }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Provincia') }}</strong></label>
        <p>{{ restaurantForm.province }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Pais') }}</strong></label>
        <p>{{ restaurantForm.country }}</p>
      </div>

      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Latitud') }}</strong></label>
        <p>{{ restaurantForm.latitude }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Longitud') }}</strong></label>
        <p>{{ restaurantForm.longitude }}</p>
      </div>
      <div class="vx-col w-full mb-3 mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('Servicio') }}</h4>
      </div>
      <div class="vx-col w-full">
        <span
          class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
          v-if="restaurantForm[index]"
          v-for="(service, index) in services"
        >
          {{ service }}
        </span>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Aforo') }}</strong></label>
        <p>{{ restaurantForm.capacity }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('NumeroMesas') }}</strong></label>
        <p>{{ restaurantForm.number_tables }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Suplemento') }}</strong></label>
        <p>{{ restaurantForm.terrace_supplement }}</p>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('MetodoPago') }}</h4>
      </div>
      <div class="vx-col w-full mb-3">
        <span
          class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
          v-if="restaurantForm[index]"
          v-for="(pay, index) in payment"
        >
          {{ pay }}
        </span>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('Horario') }}</h4>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row">
          <div class="vx-col md:w-2/12 w-full flex"></div>
          <div class="vx-col md:w-4/12 w-full">
            <p>{{ $t('HorarioManyana') }}</p>
          </div>
          <div class="vx-col md:w-4/12 w-full">
            <p>{{ $t('HorarioTarde') }}</p>
          </div>
        </div>
        <div class="vx-row mt-3 items-center" v-if="restaurantForm.schedules" v-for="(values, day) in restaurantForm.schedules">
          <div class="vx-col md:w-2/12 w-full flex">
            <p>{{ translateDays[day] }}</p>
          </div>
          <div class="vx-col md:w-4/12 w-full">
            <vx-input-group class="">
              <TimeRangeInput :disabled="true" :value="{fromTime: values.open[0], toTime: values.close[0]}"></TimeRangeInput>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-4/12 w-full">
            <vx-input-group class="">
              <TimeRangeInput :disabled="true" :value="{fromTime: values.open[1], toTime: values.close[1]}"></TimeRangeInput>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-2/12 w-full">
            <vx-input-group class="">
              <label class="mt-2">{{ $t('Cerrado') }}</label>
              <vs-switch :disabled="true" v-model="closeArray[day]" />
            </vx-input-group>
          </div>
        </div>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">ERP</h4>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Nombre') }}</strong></label>
        <p>{{ restaurantForm.name_erp }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Fabricante') }}</strong></label>
        <p>{{ restaurantForm.manufacturer_erp }}</p>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Version') }}</strong></label>
        <p>{{ restaurantForm.version_erp }}</p>
      </div>
      <div class="vx-col w-full mt-6 mb-3">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('DatosFiscales') }}</h4>
      </div>
      <div v-if="restaurantForm.address_invoice" class="vx-col w-full mt-3">
        <div class="vx-row">
          <div class="vx-col w-full mt-3">
            <h5><strong>{{ $t('DireccionFacturacion') }}</strong></h5>
          </div>
          <div class="vx-col md:w-2/3 w-full mb-3">
            <label><strong>{{ $t('Address') }}</strong></label>
            <p>{{ restaurantForm.address_invoice }}</p>
          </div>
          <div class="vx-col md:w-1/3 w-full mb-3">
            <label><strong>{{ $t('CodigoPostal') }}</strong></label>
            <p>{{ restaurantForm.cp_invoice }}</p>
          </div>
          <div class="vx-col md:w-1/3 w-full mb-3">
            <label><strong>{{ $t('Municipio') }}</strong></label>
            <p>{{ restaurantForm.municipality_invoice }}</p>
          </div>
          <div class="vx-col md:w-1/3 w-full mb-3">
            <label><strong>{{ $t('Provincia') }}</strong></label>
            <p>{{ restaurantForm.province_invoice }}</p>
          </div>
          <div class="vx-col md:w-1/3 w-full mb-3">
            <label><strong>{{ $t('Pais') }}</strong></label>
            <p>{{ restaurantForm.country_invoice }}</p>
          </div>
        </div>
      </div>
      <div class="vx-col w-full mt-3">
        <h5><strong>{{ $t('SerieFactura') }}</strong></h5>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-3">
        <label><strong>{{ $t('Serie') }}</strong></label>
        <p>{{ restaurantForm.invoice_serie }}</p>
      </div>
      <div class="vx-col w-full mt-6 mb-4" v-if="files">
        <h4 class="text-uppercase font-bold text-xl">{{ $t('ImagenCabecera') }}</h4>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3" v-for="image in files">
        <img :src="image.url" />
      </div>
    </div>
  </div>
</template>

<script>
import { DxHtmlEditor, DxToolbar, DxItem } from 'devextreme-vue/html-editor';
import { mapActions, mapGetters } from 'vuex';
import ImageDropzone from '../ImageDropzone';
import TimeRangeInput from '../time-range-input/TimeRangeInput.vue';
export default {
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
  },
  components: {
    DxHtmlEditor,
    DxToolbar,
    DxItem,
    ImageDropzone,
    TimeRangeInput
  },
  data () {
    return {
      restaurantForm: {},
      files: {},
      translateDays: {
        Monday: 'Lunes',
        Tuesday: 'Martes',
        Wednesday: 'Miércoles',
        Thursday: 'Jueves',
        Friday: 'Viernes',
        Saturday: 'Sábado',
        Sunday: 'Domingo',
      },
      closeArray: {
        Monday: true,
        Tuesday: true,
        Wednesday: true,
        Thursday: true,
        Friday: true,
        Saturday: true,
        Sunday: true,
      },
      services: {
        animation: this.$t('services.Animacion'),
        covid_free: this.$t('services.LibreDeCovid'),
        digital_menu: this.$t('services.MenuDigital'),
        food_delivery:this.$t('services.EntregaComida'),
        kid_area: this.$t('services.AreaNinos'),
        kid_friendly: this.$t('services.NinosFriendly'),
        parking: this.$t('services.Parking'),
        pet_friendly: this.$t('services.MascotasFriendly'),
        pmr: this.$t('services.PersonasMovibilidadReducida'),
        pool: this.$t('services.Piscina'),
        privatizable: this.$t('services.Privatizable'),
        terrace: this.$t('services.Terraza'),
        wifi: this.$t('services.Wifi'),
      },
      payment: {
        card_payment: this.$t('services.PargoTarjeta'),
        cash_payment: this.$t('services.PagoEfectivo'),
      },
    };
  },
  created () {

    this.restaurantForm = this.createRestaurantForm(this.restaurant);
    const files = new Array();
    if (this.restaurantForm.images) {
      this.restaurantForm.images.forEach(function (element) {
        const image = {
          name: element.path,
          url: element.path,
          urlDelete: `/webadmin/restaurants/delete_image/${element.id}`,
        };
        files.push(image);
      });
    }
    this.files = files;
  },
  computed: {
    ...mapGetters({
      listTypes: 'getListTypeRestaurant',
      listProfiles: 'getListProfileRestaurant',
      listLanguages: 'getListLanguagesRestaurant',
      languages: 'getLanguages',
      language: 'getCurrentLanguage',
    }),
  },
  methods: {
    createRestaurantForm (restaurant) {
      const typesArray = new Array();
      const profilesArray = new Array();
      const languagesArray = new Array();
      const schedulesArray = {
        Monday: {
          open: {},
          close: {},
        },
        Tuesday: {
          open: {},
          close: {},
        },
        Wednesday: {
          open: {},
          close: {},
        },
        Thursday: {
          open: {},
          close: {},
        },
        Friday: {
          open: {},
          close: {},
        },
        Saturday: {
          open: {},
          close: {},
        },
        Sunday: {
          open: {},
          close: {},
        },
      };

      if (restaurant.types.length > 0) {
        restaurant.types.forEach(function (element) {
          typesArray.push(element.id);
        });
      }
      if (restaurant.profiles.length > 0) {
        restaurant.profiles.forEach(function (element) {
          profilesArray.push(element.id);
        });
      }
      if (restaurant.languages) {
        const auxLang = JSON.parse(restaurant.languages);
        if (auxLang.length > 0) {
          auxLang.forEach(function (element) {
            languagesArray.push(element);
          });
        }
      }
      if (restaurant.schedule) {
        const auxClose = this.closeArray;
        restaurant.schedule.forEach(function (element) {
          let empty = true;
          if (element.open[0]) {
            schedulesArray[element.day].open[0] = element.open[0];

            empty = false;
          }
          if (element.close[0]) {
            schedulesArray[element.day].close[0] = element.close[0];

            empty = false;
          }
          if (element.open[1]) {
            schedulesArray[element.day].open[1] = element.open[1];

            empty = false;
          }
          if (element.close[1]) {
            schedulesArray[element.day].close[1] = element.close[1];

            empty = false;
          }
          auxClose[element.day] = empty;
        });
      }
      return {
        id: restaurant.id,
        slug: restaurant.slug,
        address: restaurant.address,
        animation: restaurant.animation,
        capacity: restaurant.capacity,
        card_payment: restaurant.card_payment,
        cash_payment: restaurant.cash_payment,
        cif: restaurant.cif,
        company_name: restaurant.company_name,
        country: restaurant.country,
        covid_free: restaurant.covid_free,
        description: restaurant.description,
        digital_menu: restaurant.digital_menu,
        email: restaurant.email,
        food_delivery: restaurant.food_delivery,
        images: restaurant.images,
        iva: restaurant.iva,
        kid_friendly: restaurant.kid_friendly,
        kid_area: restaurant.kid_area,
        latitude: restaurant.latitude,
        longitude: restaurant.longitude,
        municipality: restaurant.municipality,
        name: restaurant.name,
        number_tables: restaurant.number_tables,
        parking: restaurant.parking,
        pet_friendly: restaurant.pet_friendly,
        phone_bookings: restaurant.phone_bookings,
        phone_management: restaurant.phone_management,
        whatsapp: restaurant.whatsapp,
        pmr: restaurant.pmr,
        pool: restaurant.pool,
        postalCode: restaurant.postalCode,
        prices: restaurant.prices,
        privatizable: restaurant.privatizable,
        profiles: profilesArray,
        province: restaurant.province,
        responsable_name: restaurant.responsable_name,
        responsable_phone: restaurant.responsable_phone,
        responsable_position: restaurant.responsable_position,
        responsable_name_2: restaurant.responsable_name_2,
        responsable_phone_2: restaurant.responsable_phone_2,
        responsable_position_2: restaurant.responsable_position_2,
        terrace: restaurant.terrace,
        terrace_supplement: restaurant.terrace_supplement,
        wifi: restaurant.wifi,
        name_erp: restaurant.name_erp,
        version_erp: restaurant.version_erp,
        manufacturer_erp: restaurant.manufacturer_erp,
        languages: languagesArray,
        schedules: schedulesArray,
        types: typesArray,
        web: restaurant.web,
        invoice_serie: restaurant.invoice_serie,
        address_invoice: restaurant.address_invoice,
        country_invoice: restaurant.country_invoice,
        cp_invoice: restaurant.cp_invoice,
        province_invoice: restaurant.province_invoice,
        municipality_invoice: restaurant.municipality_invoice,
      };
    },
  },
};
</script>
